/*jslint indent: 2 */
/*global
d3, $
*/
var equipmentShades = ['#b9d263', '#c7db82', '#e3edc0'];
var utilityCapexShades = ['#f4b446', '#f6c36b', '#fbe1b5', '#bb6d49', '#c88a6d', '#e4c4b6'];
var utilityOpexShades = ['#4fbded', '#72caf1', '#b9e5f8', '#66cc99', '#9ddebd'];
var utilityShades = ['#666d6a', '#757d79', '#848d88', '#939d98', '#9da6a2', '#a8b0ac', '#b3bab6'];
var industrialOpexShades = ['#5c4187', '#7d679f', '#beb3cf', '#89357a', '#a05e95', '#d0aeca', '#cc4c96', '#d670ab', '#eab7d5', '#f3d4e6'];
var industrialCapexShades = ['#8d4e47', '#a4726c', '#d2b8b5'];
var industrialShades = ['#2e4241', '#617574', '#889797'];
var chemicalShades = ['#2898c1', '#5bcbf4', '#84d8f7'];
var utilityCapexShadesObj = {};
var utilityOpexShadesObj = {};
var chemicalShadesObj = {};
var industrialShadesObj = {};
var industrialOpexShadesObj = {};
var industrialCapexShadesObj = {};
var utilityShadesObj = {};
var equipmentShadesObj = {};

window.makeSunburst = function (baseContainerSelector, dataSelector, defaultValueKey, data, valueFormatter, showLabel, chartTitle) {
    var foreignObjectSupport = !!document.createElementNS && /SVGForeignObject/.test(({}).toString.call(document.createElementNS("http://www.w3.org/2000/svg", "foreignObject")));
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    return function () {
        var fakeExtraEmptyCirclesName = "hideme";
        var d3BaseContainer = d3.select(baseContainerSelector);
        var resetControlSelector = ".reset-control";
        var rootNodeName = "Total";
        var centerLegendClass = "sunburst-center-legend";
        var centerLegendSelector = "." + centerLegendClass;
        var baseContainer = document.querySelector(baseContainerSelector);
        var resetControl = baseContainer?.querySelector(resetControlSelector);
        var hideElement = function (element) {
            if (element) element.style.display = 'none';
        };
        var showElement = function (element) {
            if (element) element.style.display = '';
        };
        var breadcrumbSelector = ".sunburst-breadcrumbs";
        var epsilon = 1e-6;
        var format = valueFormatter;

        var sameNodes = function (node1, node2) {
            return node1.id === node2.id && node1.parent === node2.parent;
        };

        // Given a node in a partition layout, return an array of all of its ancestor
        // nodes, highest first, but excluding the root.
        var getAncestors = function (node) {
            var path = [];
            var current = node;
            while (current.parent) {
                path.unshift(current);
                current = current.parent;
            }
            return path;
        };

        // Breadcrumb dimensions: width, height, spacing, width of tip/tail.
        var b = {
            w: 125, h: 100, s: 3, t: 10
        };

        var initializeBreadcrumbTrail = function () {
            // Add the svg area.
            var trail = d3BaseContainer.select(breadcrumbSelector).append("svg:svg")
            .attr("preserveAspectRatio", "xMinYMin meet")
            .attr("viewBox", viewBoxForCrumbs)
            .attr("class", "trail secondary-visualization");
            // Add the label at the end, for the percentage.
            trail.append("svg:text")
            .attr("class", "endlabel")
            .style("fill", "#000");
        };

        var recursiveCrumbWidth = function (d, acc) {
            if (d.parent && d.parent.name !== rootNodeName) {
                var newAcc = acc + crumbWidth(d.parent) + b.s;
                return recursiveCrumbWidth(d.parent, newAcc);
            } else {
                return acc;
            }
        };

        var crumbWidth = function (d) {
            return 60 + (width / 65) * d.name.length;
        };

        // Generate a string that describes the points of a breadcrumb polygon.
        var breadcrumbPoints = function (d, i) {
            var width = crumbWidth(d);
            var points = [];
            points.push("0,0");
            points.push(width + ",0");
            points.push(width + b.t + "," + (b.h / 2));
            points.push(width + "," + b.h);
            points.push("0," + b.h);
            if (i > 0) { // Leftmost breadcrumb; don't include 6th vertex.
                points.push(b.t + "," + (b.h / 2));
            }
            return points.join(" ");
        };

        // Update the breadcrumb trail to show the current sequence and percentage.
        var updateBreadcrumbs = function (nodeArray) {
            // Data join; key function combines name and depth (= position in sequence).
            var g = d3BaseContainer.select(".trail")
            .selectAll("g")
            .data(nodeArray, function(d) { return d.name + d.depth; });

            g.on("click", function (d) {
                resetChartTo(d);
            });

            g.on("mouseover", function (d) {
                if (sameNodes(d, node)) {
                    return;
                }

                g.selectAll("polygon")
                .attr("opacity", function(innerD) {
                    return sameNodes(innerD, d) ? 0.65 : 1;
                });

                crumbTip
                .show(d, this)
                .style("top", (d3.event.pageY + 16) + "px")
                .style("left", (d3.event.pageX + 16) + "px");
            });

            g.on("mouseout", function (d) {
                g.selectAll("polygon")
                .attr("opacity", 1);

                crumbTip.hide(d);
            });

            // Add breadcrumb and label for entering nodes.
            var entering = g.enter().append("svg:g");

            entering.append("svg:polygon")
            .attr("points", breadcrumbPoints)
            .attr("class", "clickable")
            .style("fill", colorForNodeCrumbs);

            var xOffset = b.t + 3;
            if (foreignObjectSupport) {
                entering.append("svg:foreignObject")
                .attr("x", function (d, i) { return i > 0 ? xOffset : xOffset / 2; })
                .attr("y", 4)
                .attr("width", function (d) { return crumbWidth(d) - b.t - xOffset; })
                .attr("height", b.h - b.h / 10)
                .attr("class", "clickable")
                .html(function(d) { return "<div class='breadcrumb-parent'><div class='breadcrumb-label'>" + d.name + "</div></div>"; });
            } else {
                var textSize = 30;

                entering.append("text")
                .attr("x", function (d, i) { return i > 0 ? xOffset : xOffset / 2; })
                .attr("y", 4)
                .attr("width", function (d) { return crumbWidth(d) - b.t - xOffset; })
                .attr("height", b.h - b.h / 10)
                .attr("class", "clickable")
                .append("tspan")
                .attr("class", "tspan-breadcrumb-label")
                .attr("y", b.h / 2 + textSize / 4)
                .attr("x", 15)
                .attr("font-size", textSize)
                .attr("fill", "white")
                .text(function(d) { return d.name; });
            }

            // Set position for entering and updating nodes.
            g.attr("transform", function(d, i) {
                var xTranslate = recursiveCrumbWidth(d, 0);
                var tooLong = xTranslate + crumbWidth(d) > viewBoxWidth;  //&& $(this).parent().width() < 270
                if (tooLong) {
                    return "translate(20, 100)";
                } else {
                    return "translate(" + xTranslate + ", 0)";
                }
            });

            // Remove exiting nodes.
            g.exit().remove();

            // Make the breadcrumb trail visible, if it's hidden.
            d3BaseContainer.select(".trail")
            .style("visibility", "");

        };

        var rootNodeToggles = function (atRootNode) {
            var centerLegend = baseContainer?.querySelector(centerLegendSelector);

            if (atRootNode) {
                hideElement(resetControl);
                d3BaseContainer.select(".trail")
                .style("visibility", "hidden");
                showElement(centerLegend);
            } else {
                showElement(resetControl);
                // centerLegend.hide();
            }
        };

        var resetChartTo = function (destinationNode) {
            node = destinationNode;
            var atRootNode = node.id === rootNode.id;
            path.transition()
            .duration(1000)
            .attrTween("d", arcTweenZoom(destinationNode))
            .style("fill", colorForNode);

            svg.select("." + centerLegendClass)
            .html("<div>" + node.name + "<br/>" + format(node.value) + "</div>");
            rootNodeToggles(atRootNode);

            var sequenceArray = getAncestors(destinationNode);
            updateBreadcrumbs(sequenceArray);

            updateInnerLegend();
        };

        var updateInnerLegend = function () {
            var legendColor = colorForNodeCrumbs(node);
            legendColor = legendColor === "white" ? "black" : legendColor;
            var parentColor;
            if (node.parent) {
                parentColor = colorForNodeCrumbs(node.parent);
                parentColor = parentColor === "white" ? "black" : parentColor;
            }
            var parentName = node.parent ? "(back to " + node.parent.name + ")" : "";
            var centerLegendContainer = svg.select("." + centerLegendClass);

            if (foreignObjectSupport) {
                var legendHtml = "<div style='color: " + legendColor + ";'>" + node.name + "<br/>" + format(node.value) + "</div><div><a href='#' class='legend-go-back-a-level' style='color: " + parentColor + "'>" + parentName + "</a></div>";
                centerLegendContainer.html(legendHtml);
            } else {
                centerLegendContainer.selectAll("tspan").data([]).exit().remove();

                centerLegendContainer
                .style("color", legendColor);
                centerLegendContainer
                .append("tspan")
                .attr("x", 0)
                .attr("y", textY)
                .text(node.name);
                centerLegendContainer
                .append("tspan")
                .attr("x", 0)
                .attr("y", textY + 50)
                .text(format(node.value));
                centerLegendContainer
                .append("tspan")
                .attr("x", 0)
                .attr("y", textY + 100)
                .attr("class", "legend-go-back-a-level")
                .style("color", parentColor)
                .text(parentName);
            }

            baseContainer?.querySelectorAll('.legend-go-back-a-level').forEach(function (link) {
                link.addEventListener('click', function (e) {
                    resetChartTo(node.parent);
                    e.preventDefault();
                });
            });
        };

        var click = function (d) {
            if (d.name === fakeExtraEmptyCirclesName) {
                return;
            }
            if (d.depth > 0) {
                rootNodeToggles(false);
            } else {
                rootNodeToggles(true);
            }

            if (node.id === d.id) {
                return;
            }

            node = d;

            updateInnerLegend();

            path.transition()
            .duration(1000)
            .attrTween("d", arcTweenZoom(d))
            .style("fill", colorForNode);
        };

        var mouseover = function (d) {
            if (d.name === fakeExtraEmptyCirclesName) {
                return;
            }
            // No tooltip for root node;
            if (d.name == rootNodeName) {
                return;
            }

            // No tooltip for center node;
            if (d.name == node.name) {
                return;
            }

            // http://stackoverflow.com/a/17917341/1908371 Append this so that it draws on top of the other children
            var name = d.name;
            var parent = d.parent;
            d3BaseContainer.selectAll("path")
            .attr("opacity", function(d) {
                var same = d.name == name && d.parent == parent;
                return same ? 0.65 : 1;
            });

            tip
            .show(d)
            .style("top", (d3.event.pageY + 16) + "px")
            .style("left", (d3.event.pageX + 16) + "px");

            var sequenceArray = getAncestors(d);
            updateBreadcrumbs(sequenceArray);
        };

        var nextColor = function (colors) {
            var color = colors[0];
            colors.shift()
            colors.push(color);
            return color;
        };

        var createObjOrReturn = function (obj, key) {
            if (!window[obj][key]){
                window[obj][key] = nextColor(window[obj.split('Obj')[0]]);
            }
            return window[obj][key];
        };

        var mouseout = function (d) {
            d3BaseContainer.selectAll("path")
            .attr("opacity", 1);
            tip.hide(d);
            // Hide the breadcrumb trail
            if (node.name === rootNodeName) {
                d3BaseContainer.select(".trail")
                .style("visibility", "hidden");
            } else {
                var sequenceArray = getAncestors(node);
                updateBreadcrumbs(sequenceArray);
            }
        };

        var tooltip = function(d) {
            var tipColor = colorForNode(d),
            xval = d.name,
            yval = format(d.value),
            seriesText = "";
            return "<div style=\"box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3);\"><div style=\"background-color: white; padding: 10px; border-top: 8px solid " + tipColor + "\">" + "<b>" + xval + "</b>" + seriesText + "</div><div style=\"background-color: white; padding: 0px 10px 10px 10px; font-weight: bold; font-size: 14px; color: " + tipColor + "\">" + yval + "</div></div>";
        };

        var crumbTooltip = function() {
            return "<div style=\"box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.3); padding: 10px; background-color: white;\"><div>Click to return to this level.</div></div>";
        };

        var changeFunc = function () {
            var value = this.value;
            var makeValue = function(d) { return d[defaultValueKey]; };

            if (value) {
                makeValue = function(d) { return d[value]; };
            }

            path
            .data(partition.value(makeValue).nodes)
            .transition()
            .duration(1000)
            .attrTween("d", arcTweenData);
            updateInnerLegend();
        };

        // When switching data: interpolate the arcs in data space.
        var arcTweenData = function (a, i) {
            var oi = d3.interpolate({x: a.x0, dx: a.dx0}, a);
            var tween = function (t) {
                var b = oi(t);
                a.x0 = b.x;
                a.dx0 = b.dx;
                return arc(b);
            };
            if (i == 0) {
                // If we are on the first arc, adjust the x domain to match the rootNode node
                // at the current zoom level. (We only need to do this once.)
                var xd = d3.interpolate(x.domain(), [node.x, node.x + node.dx]);
                return function(t) {
                    x.domain(xd(t));
                    return tween(t);
                };
            } else {
                return tween;
            }
        };

        // When zooming: interpolate the scales.
        var arcTweenZoom = function (d) {
            var xd = d3.interpolate(x.domain(), [d.x, d.x + d.dx]),
                yd = d3.interpolate(y.domain(), [d.y, 1]),
                yr = d3.interpolate(y.range(), [d.y ? 20 : 0, radius]);
            return function(d, i) {
                return i
                ? function() { return arc(d); }
                : function(t) { x.domain(xd(t)); y.domain(yd(t)).range(yr(t)); return arc(d); };
            };
        };

        var width = 960,
            height = 960,
            radius = Math.min(width, height) / 2,
            strokeColor = "white",
            strokeWidth = 1,
            viewBoxWidth = width + 100,
            viewBoxHeight = height + 100,
            viewBox = "0 0 " + viewBoxWidth + " " + viewBoxHeight,
            viewBoxForCrumbs = "0 0 " + (width + 100) + " " + (100);

        var x = d3.scale.linear()
        .range([0, 2 * Math.PI]);

        var y = d3.scale.sqrt()
        .range([0, radius]);

        var colorForNodeCrumbs = function (d) {
            return colorForNode(d, "ignore");
        };

        var colorForNode = function (d, extraThing) {
            var ignore = extraThing === "ignore";

            if (!ignore) {
                var lastLevel = !node.children;
                if (!lastLevel && d.id === node.id) {
                    return "white";
                }

                if (node.parent && d.id === node.parent.id) {
                    return "white";
                }
            }

            var categories = {
                "Chemicals": "#3282b9",
                "Civil engineering": "#f4b446",
                "Design costs": "#f4b446",
                "Electrical energy": "#f6c36b",
                "Energy recovery devices": "#fbe1b5",
                "Equipment / materials": "#acc945",
                "Installation / services": "#c7db82",
                "Intakes / outfalls": "#acc945",
                "Labour": "#c7db82",
                "Legal / professional costs": "#acc945",
                "Membranes": "#c7db82",
                "Parts": "#54925b",
                "Pipes / High grade alloys": "#76a77c",
                "Pressure vessels": "#bbd3be",
                "Pretreatment": "#66cc99",
                "Pumps": "#85d6ad",
                "Thermal energy":"#c2ebd6",
                "Thermal fabrication": "#4fbded",
                "Permitting / development": "#d3e29c",
                "Monitoring / control": "#647722",
                "Agricultural irrigation": "#c7db82",
                "Direct potable reuse": "#54925b",
                "Environmental enhancement": "#76a77c",
                "Groundwater recharge": "#bbd3be",
                "Indirect potable reuse": "#66cc99",
                "Industrial": "#85d6ad",
                "Landscape irrigation": "#c2ebd6",
                "Other/unknown": "#4fbded",
                "Recreational use": "#d3e29c",
                "Urban non-potable use": "#647722"
            };


            var regionColors = {
                "MENA": "#72caf1",
                "Latin America": "#B46D4F",
                "GCC": "#549363",
                "North America": "#f1ab8c",
                "Sub-Saharan Africa": "#843C81",
                "Caribbean": "#F3B050",
                "Asia / Pacific": "#3A5352",
                "Europe": "#78857F"
            };

            var productColor = regionColors[d.name] || categories[d.name];
            if (productColor) return productColor;

            if (d.name === rootNodeName) {
                return "white";
            } else if (d.name === "OPEX") {
                return "#3384B7";
            } else if (d.name === "CAPEX") {
                return "#C84646";
            } else if (d.parent.name === "Utility" && d.parent.parent.name === "CAPEX") {
                return createObjOrReturn('utilityCapexShadesObj', d.id);
            } else if (d.parent.name === "Utility" && d.parent.parent.name === "OPEX") {
                return createObjOrReturn('utilityOpexShadesObj', d.id);
            } else if (d.parent.name === "Industrial" && d.parent.parent.name === "CAPEX") {
                return createObjOrReturn('industrialCapexShadesObj', d.id);
            } else if (d.parent.name === "Industrial" && d.parent.parent.name === "OPEX") {
                return createObjOrReturn('industrialOpexShadesObj', d.id);
            } else if (d.parent && !d.parent.parent) {
                if (regionColors[d.name]) {
                  return regionColors[d.name]["color"];
                }
                return "red";
            } else if (d.parent && d.parent.parent && d.parent.parent.name === "Industrial") {
                return createObjOrReturn('industrialShadesObj', d.id);
            } else if (d.parent && d.parent.parent && d.parent.parent.name === "Utility") {
                return createObjOrReturn('utilityShadesObj', d.id);
            } else if ((d.parent.parent.name === rootNodeName && d.parent.name === "Equipment") || (d.parent.parent.parent && d.parent.parent.parent.name === rootNodeName && d.parent.parent.name === "Equipment")) {
                if (d.name === 'hideme') return null;

                return createObjOrReturn('equipmentShadesObj', d.id);
            } else if ((d.parent.parent.name === rootNodeName && d.parent.name === "Services") || (d.parent.parent.parent && d.parent.parent.parent.name === rootNodeName && d.parent.parent.name === "Services")) {
                return "#F4C480";
            } else if (d.parent.parent.name === rootNodeName && d.parent.name === "Chemicals") {
                return createObjOrReturn('chemicalShadesObj', d.id);
            } else if (d.parent.parent.name === rootNodeName && d.parent.name === "Other project costs") {
                return "#C9539F";
            } else if (d.parent && regionColors[d.parent.name] && regionColors[d.parent.name][d.name]) {
              return regionColors[d.parent.name][d.name]["color"];
            } else if (d.parent && d.parent.parent && regionColors[d.parent.parent.name] && regionColors[d.parent.parent.name][d.parent.name] && regionColors[d.parent.parent.name][d.parent.name][d.name]) {
              return regionColors[d.parent.parent.name][d.parent.name][d.name]["color"];
            } else if (d.parent && d.parent.parent && regionColors[d.parent.parent.name] && regionColors[d.parent.parent.name][d.parent.name]) {
              return regionColors[d.parent.parent.name][d.parent.name]["allChildrenColor"];
            } else {
                return "black";
            }
        };

        var svg = d3BaseContainer.append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("viewBox", viewBox)
        .attr("xmlns", "http://www.w3.org/2000/svg")
        .attr("xmlns:xlink", "http://www.w3.org/1999/xlink")
        .append("g")
        .attr("transform", "translate(" + viewBoxWidth / 2 + "," + (height / 2 + 10) + ")");

        var partition = d3.layout.partition()
        .sort(null)
        .value(function(d) { return d[defaultValueKey]; });

        var arc = d3.svg.arc()
        .startAngle(function(d) { return Math.max(0, Math.min(2 * Math.PI, (x(d.x) - epsilon))); })
        .endAngle(function(d) { return Math.max(0, Math.min(2 * Math.PI, (x(d.x + d.dx) - epsilon) )); })
        .innerRadius(function(d) {
            var val = Math.max(0, y(d.y));

            if (node.id === d.id && !node.children) {
                return 240;
            }

            return val;
        })
        .outerRadius(function(d) {
            var val = Math.max(0, y(d.y + d.dy));
            if (node.parent && d.id === node.parent.id && !node.children) {
                return 240;
            }

            if (node.id === d.id && !node.children) {
                return Math.max(440, val);
            }

            return val;
        });

        if (!format) {
            format = function (d) {
                var rounder = d.toFixed().length >= 3 ? d.toFixed().length : 3
                var base = d3.format(",."+ rounder + "r")(d);

                return "$" + base + " million";
            };
        }

        var tip = d3.tip()
        .attr("class", "d3-tip")
        .direction("n")
        .html(tooltip);
        var crumbTip = d3.tip()
        .attr("class", "d3-crumb-tip")
        .direction("n")
        .html(crumbTooltip);

        svg.call(tip);
        svg.call(crumbTip);

        var rootNode = { name: rootNodeName, children: data[dataSelector], id: "id-Total" };
        var node = rootNode;

        // Setup for switching data: stash the old values for transition.
        var stash = function (d) {
            d.x0 = d.x;
            d.dx0 = d.dx;
        };

        var path = svg.datum(rootNode).selectAll("path")
        .data(partition.nodes)
        .enter().append("path")
        .attr("d", arc)
        .attr("stroke", strokeColor)
        .attr("stroke-width", strokeWidth)
        .style("fill", colorForNode)
        .on("click", click)
        .on("mouseover", mouseover)
        .on("mouseout", mouseout)
        .each(stash);

        var textWidth = radius / 2 + 100;
        var textX = -textWidth / 2;
        var textY;
        if (document.getElementsByClassName("ie").length) {
            textY = -radius / 6 + 50;
        } else {
            textY = -radius / 6;
        }

        if (foreignObjectSupport) {
            // var centerLegendText = function (rnn, val) {
            //     return "<div>" + rnn + "<br/>" + format(val) + "</div>";
            //   } else {
            //     return "<tspan>" + rnn + "</tspan><tspan>" + format(val) + "</tspan>";
            //   }
            // };
            svg.append("foreignObject")
            .attr("class", "center-text " + centerLegendClass)
            .attr("width", textWidth)
            .attr("height", 250)
            .attr("x", textX)
            .attr("y", textY)
            .style("font-size", 36)
            .html("<div>" + rootNodeName + "<br/>" + format(rootNode.value) + "</div>");

            if (showLabel) {
                var labelText = chartTitle || "";
                svg.append("foreignObject")
                .attr("class", "center-text " + centerLegendClass)
                .attr("width", textWidth)
                .attr("height", 50)
                .attr("x", textX)
                .attr("y", textY -100)
                .style("font-size", 36)
                .html("<div class='capitalize'>" + labelText + "</div>");
            }
        } else {
            var textAlternativeCenter = svg.append("text")
            .attr("class", "center-text " + centerLegendClass)
            .attr("width", textWidth)
            .attr("height", 100)
            .attr("x", 0)
            .attr("y", textY)
            .attr("text-anchor", "middle")
            .style("font-size", "34px");
            textAlternativeCenter
            .append("tspan")
            .attr("x", 0)
            .attr("y", textY)
            .text(rootNodeName);
            textAlternativeCenter
            .append("tspan")
            .attr("x", 0)
            .attr("y", textY + 50)
            .text(format(rootNode.value));
        }

        var inputArrows = function (arrow) {
            var input = arrow.parentElement?.querySelector('input');
            if (!input) return;
            var baseVal = parseInt(input.value, 10);

            if (arrow.className.match(/up/) && baseVal < parseInt(input.getAttribute('max'), 10)) {
                baseVal++;
            } else if (arrow.className.match(/down/) && baseVal > parseInt(input.getAttribute('min'), 10)) {
                baseVal--;
            }

            if (baseVal == parseInt(input.value, 10)) return;
            input.value = String(baseVal);
            input.dispatchEvent(new Event('change', { bubbles: true }));
            changeFunc.call(input[0]);
        };

        d3BaseContainer.selectAll("[class^=arrow-]").on("click", function () {
            inputArrows(this);
        });

        d3BaseContainer.selectAll("input, select").on("change", changeFunc);

        d3.select(self.frameElement).style("height", height + "px");

        initializeBreadcrumbTrail();

        if (resetControl) {
            if (isMobile) {
                resetControl.addEventListener('click', function (e) {
                    resetChartTo(rootNode);
                    e.preventDefault();
                });
            }

            resetControl.addEventListener('click', function (e) {
                resetChartTo(rootNode);
                e.preventDefault();
            });
        }
    };
};
